import React from 'react';

import ProgramLogos from '../components/ProgramLogos';

const Widget = () => {
	return <ProgramLogos />;
};

export default Widget;
